import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiKey: undefined,
    jwt: undefined,
    loggedIn: false,
    storeId: localStorage.getItem("selected_store"),
    companyId: localStorage.getItem("selected_company"),
    businessunits:[],
    rosterFromTo: undefined, 
    accountPreference: JSON.parse(localStorage.getItem("accountPreference")),
    permissions: {}
  },
  getters: {
    getJwt: state => () => state.jwt,
    getLoggedIn: state => () => state.loggedIn,
    getStoreId: state => () => state.storeId,
    getRosterFromTo: state => () => state.rosterFromTo,
    getAccountPreference: state => () => state.accountPreference,
    getPermissions: state => () => state.permissions,
  },
  mutations: {
    setApiKey: function (state, payload) {
      state.apiKey = payload.apiKey;
    },
    setStoreId: function (state, payload) {
      state.storeId = payload.storeId;
      localStorage.setItem("selected_store", payload.storeId);
    },
    setCompanyId: function (state, payload) {
      state.companyId = payload.companyId;
      localStorage.setItem("selected_company", payload.companyId);
    },
    setJWT: function (state, payload) {
      state.jwt = payload.jwt;
      //localStorage.setItem("md_token", payload.jwt);
    },
    setLoggedIn: function (state, payload) {
      state.loggedIn = payload.loggedIn;
    },
    setAccountPreference: function (state, payload) {
      state.accountPreference = payload;
      localStorage.setItem("accountPreference", JSON.stringify(payload));
    },
    clearJWT: function (state){
      state.jwt = null;
      localStorage.removeItem("md_token");
    },
    setRosterFromTo: function(state, payload){
      state.rosterFromTo = Object.assign({}, payload.rosterFromTo);
    },
    setPermissions: function(state, payload){
      state.permission = Object.assign({}, payload.permissions);
    }
  },
  actions: {

  }
})
